module.exports = "https://static.wmbcdn.com/uniweb/images/44d015b773f1c362a3be009f0b3bef82.svg";